import {Component, inject, Input} from '@angular/core';
import {VideoService, YouTube} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'app-youtube-preview',
  template: `
    <a [href]="url" target="_blank" class="video-preview">
      <img [src]="previewUrl | async" loading="lazy" alt="">
    </a>`,
  styles: `
    .video-preview {
      width: 150px;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }`,
  imports: [AsyncPipe]
})
export class VideoPreviewComponent {
  previewUrl: Observable<string>;
  url: string;

  @Input() fallbackSrc = '/assets/images/product/video.svg';

  private readonly videoService = inject(VideoService);

  @Input() set model(value: YouTube) {
    this.previewUrl = this.videoService.getVideoPreview(value).pipe(
      map(src => src || this.fallbackSrc)
    );
    this.url = this.videoService.getVideoUrl(value);
  }
}
